module.exports = __webpack_public_path__ + "static/img/point_jindou.ca862bd9.png";